<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em;">Clive Graham Lord worked at Sotheby’s in New Bond Street, London for 22 years, the last 15 of them as chief operating officer. Many of the incidents, apart from the murders of course, are based on real-life experiences and have been woven into the book with a little added literary license.</p><br/>
<p style="text-indent:00em;">This is Clive’s first novel since moving from Sotheby’s in 2020; he lives in London and Surrey with his partner.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?51789c58